import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Pagination, Slider } from 'react-slick';
import { Loader } from '../../';
import { decodeHTMLEntities } from '../../../utils';
import { dataFetchBlogPosts } from '../../../actions/blogPosts';
import { blogCarouselSlickSettings } from '../../../constants/slick';
import _ from 'lodash';

const propTypes = {
  category: PropTypes.string,
  arrows: PropTypes.string,
  posts: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  currentItem: PropTypes.object.isRequired
}

const defaultProps = {
  category: 'Bears',
  posts: [
    {
      title: 'Ursala on the Move!',
      featured_image: {
        guid: 'https://blog.explore.org/wp-content/uploads/2017/03/Winner-1-SkyBlueSue-1.jpg',
        title: 'Ursala on the Move!'
      },
      link: 'https://blog.explore.org/ursula-on-the-move/'
    },
    {
      title: 'Ursala on the Move!',
      featured_image: {
        guid: 'https://blog.explore.org/wp-content/uploads/2017/03/Winner-1-SkyBlueSue-1.jpg',
        title: 'Ursala on the Move!'
      },
      link: 'https://blog.explore.org/ursula-on-the-move/'
    }
  ]
};

class BlogCarousel extends React.Component {

  constructor(props) {
    super(props);
    this.previous = this.previous.bind(this);
    this.next = this.next.bind(this);
    this.paginationRender = this.paginationRender.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  previous() {
    this.refs.blogSlider.slickPrev();
  }

  next() {
    this.refs.blogSlider.slickNext();
  }

  componentDidMount() {
    this.props.dispatch(dataFetchBlogPosts(this.props.currentItem.blog_channel));
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.currentItem.blog_channel && this.props.currentItem.blog_channel !== nextProps.currentItem.blog_channel) {
      this.props.dispatch(dataFetchBlogPosts(nextProps.currentItem.blog_channel));
    }
  }

  paginationRender(currentPage, totalPages) {
    return (
      <div className="carousel-controller crsl-nav d-flex justify-content-between align-items-center ">
        <button className="ig-btn video-player-btn left previous" onClick={this.previous}><i className="icon-ButtonArrowLeft"></i></button>
        <div ref="slideNumber" className="video-carousel-paging"><span className="pr-10">{currentPage}</span>/<span className="pl-10">{totalPages}</span> </div>
        <button className="ig-btn video-player-btn right next" onClick={this.next}><i className="icon-ButtonArrowRight"></i></button>
      </div>
    );
  }

  getContent() {

    const { posts } = this.props;

    if (!posts || !posts.length) {
      return null;
    }

    return (
      <div>
        <div id="blog-carousel">
          <Slider {...blogCarouselSlickSettings} ref='blogSlider' paginationRender={this.paginationRender}>
            {
              posts.filter(post => !_.isEmpty(_.get(post, '_embedded.wp:featuredmedia')))
              .map((post, index) => {
                const imageTitle = _.get(post, '_embedded.wp:featuredmedia[0].title.rendered');
                const url = _.get(
                  post,
                  '_embedded.wp:featuredmedia[0].media_details.sizes.medium.source_url',
                  _.get(post, '_embedded.wp:featuredMedia[0].source_url'),
                );
                return (
                  <div className="blog-slide" key={`${post.id}-${index}`}>
                    <div className="inner-slide u-font-foundation-roman u-textSize-18">
                      <a href={post.link} target="_blank">
                        <div>
                          <img className="img-fluid" src={url} title={imageTitle} />
                        </div>
                        <div className="post-title overlay-title">{decodeHTMLEntities(post.title.rendered)}</div>
                      </a>
                    </div>
                  </div>
                );
              })
            }
          </Slider>
        </div>
        <div className="text-center" data-carousel-controls="blog-carousel">
          <div className="panel-carousel-controls-wrapper">
            <Pagination name="blog-pagination" />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { getContent } = this;
    const { posts, loading, isFetching } = this.props;
    let isLoading = !!(loading || _.isEmpty(posts)) && isFetching

    return (
      <div className={`widget carousel blog ${isLoading ? 'loading' : ''}`}>
        {
          isLoading ?
          <Loader dark fill /> :
          getContent()
        }
      </div>
    );

  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    posts: state.blogPosts.data,
    isFetching: state.blogPosts.isFetching
  };
}

BlogCarousel.propTypes = propTypes;
BlogCarousel.defaultProps = defaultProps;

export default connect(mapStateToProps)(BlogCarousel);
